import { RefreshCw } from "lucide-react";

export const CardStackIcon = ({
  size = 22,
  color = "currentColor",
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M4 8.5l8-4 8 4-8 4-8-4z"
      stroke={color}
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M4 12.5l8 4 8-4"
      stroke={color}
      strokeWidth="1.8"
      strokeLinejoin="round"
      opacity="0.55"
    />
    <path
      d="M4 16.5l8 4 8-4"
      stroke={color}
      strokeWidth="1.8"
      strokeLinejoin="round"
      opacity="0.3"
    />
  </svg>
);

export const NavCardsIcon = ({ size = 18 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
  >
    <rect
      x="3"
      y="5.5"
      width="11"
      height="11"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M6 3.5h10A1.5 1.5 0 0117.5 5v10"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const FlipIcon = ({ size = 18 }: { size?: number }) => (
  <RefreshCw
    size={size}
    strokeWidth={2.25}
    className="text-current"
    aria-hidden="true"
  />
);

export const CloseIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M3 3l10 10M13 3L3 13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
